<template>
  <div class="timeline-wrapper bg-light d-flex flex-column tw-mobile">
    <!-- Header -->
    <div
      class="bg-dark text-white d-flex align-items-center justify-content-between px-3 py-3"
    >
      <strong>{{ todayDate }} - {{ todayTime }}</strong>

      <div class="d-flex align-items-center">
        <a href="#" @click="$emit('refresh')" class="text-white mr-3">
          <i class="fas fa-fw fa-sync-alt"></i>
        </a>
        <b-button variant="secondary" size="sm" @click="$emit('switch-tab')">
          {{ $t("account_page_timeline.ci_co") }}
        </b-button>
      </div>
    </div>

    <!-- Tabs -->
    <div class="bg-white border-bottom p-2">
      <b-button-group class="w-100">
        <b-button
          v-for="tab in statusOptions"
          :key="tab.value"
          :class="
            filter.status === tab.value ? tab.activeClass : tab.inActiveClass
          "
          @click="$emit('change-status', tab.value)"
          :style="tab.style"
          variant="none"
        >
          {{ tab.text }}
          <div
            class="badge text-white"
            :class="
              filter.status === tab.value ? tab.badgeActive : tab.badgeInActive
            "
          >
            {{ counts[tab.value] }}
          </div>
        </b-button>
      </b-button-group>
    </div>

    <!-- Booking List -->
    <div class="flex-grow-1 overflow-auto p-2">
      <template v-if="bookings.length">
        <div
          v-for="booking in bookings"
          :key="booking.pass"
          class="booking-item"
          @click="openBooking(booking)"
        >
          <!-- First Row -->
          <div class="d-flex justify-content-between align-items-start">
            <div class="fw-bold">
              {{ booking.guest_name }}
            </div>

            <div class="text-end">
              <div class="small">
                <i class="fas fa-clock text-secondary"></i>

                {{ actualInOut(booking) }}
              </div>

              <div class="small">
                <i class="fas fa-bed text-secondary"></i>

                {{ booking.room_number || "--" }}
                ({{ booking.number_of_rooms || 0 }})
              </div>
            </div>

            <span
              class="badge"
              :class="
                booking.checkin_status_code === '101'
                  ? 'badge-success'
                  : 'badge-warning'
              "
            >
              {{ $t(`booking_statuses.${booking.checkin_status_code}`) }}
            </span>
          </div>

          <hr class="my-2" />

          <!-- Second Row -->
          <div class="d-flex align-items-center">
            <div class="info-item">
              <i class="fas fa-user"></i>

              {{ booking.number_of_guests || 0 }}
            </div>

            <div class="info-item payment">
              <i class="fas fa-money-bill-wave mr-2"></i>
              <span
                class="py-1 px-2"
                :class="
                  checkinCodes.includes(String(booking.payment_status_code))
                    ? 'paid'
                    : 'unpaid'
                "
              >
                {{ booking.total_charge || "0" }}
              </span>
            </div>

            <div class="info-item flex-grow-1">
              <i class="far fa-file-alt"></i>

              {{ booking.reservation_no }}
            </div>
          </div>
        </div>
      </template>

      <div v-else class="text-center py-5">
        {{ $t("account_page_timeline.no_booking") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimelineMobile",

  props: {
    bookings: Array,
    counts: Object,
    filter: Object,
    visibleTabs: Array,
    todayDate: String,
    todayTime: String,
    actualInOut: Function,
    checkinCodes: Array,
  },

  computed: {
    statusOptions() {
      return this.visibleTabs.map(
        ({
          value,
          label,
          activeClass,
          inActiveClass,
          badgeActive,
          badgeInActive,
        }) => ({
          value,
          text: this.$t(label),
          activeClass,
          inActiveClass,
          badgeActive,
          badgeInActive,
        })
      );
    },
  },

  methods: {
    openBooking(booking) {
      this.$router.push({
        name: "guest-timeline-details",
        params: {
          slug_name: this.$route.params.slug_name,
          pass: booking.pass,
          reservation_no: booking.reservation_no,
        },
      });
    },
  },
};
</script>

<style scoped>
.timeline-wrapper {
  height: 100vh;
  /* Fixes dynamic address bar scaling issues on real mobile devices */
  height: 100dvh;
  /* CRITICAL: Prevents pull-to-refresh and rubber-band bounce on the main app shell */
  overscroll-behavior-y: contain;
  /* Extra safeguard: prevents accidental horizontal swipe-to-navigate gestures */
  overscroll-behavior-x: none;
}
/* Ensure the inner list allows normal, native scrolling without triggering parent bounce */
.flex-grow-1.overflow-auto {
  overscroll-behavior-y: auto;
  -webkit-overflow-scrolling: touch; /* Liquid smooth momentum scrolling for iPadOS/iOS */
}
.timeline-wrapper .btn:focus {
  box-shadow: unset;
}

.booking-card {
  background: #fff;
  border: 1px solid #e5e7ec;
  border-radius: 10px;
  padding: 14px;
  cursor: pointer;
}

.booking-card:active {
  transform: scale(0.98);
}
.booking-item {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 8px;
}

.info-item {
  display: flex;
  align-items: center;
  margin-right: 18px;
  font-size: 14px;
}

.info-item i {
  width: 20px;
  color: #666;
}

.payment {
  padding: 2px 10px;
  border-radius: 3px;
}

.paid {
  background: #8bc34a;
  color: #000;
}

.unpaid {
  background: #ffc107;
  color: #000;
}

.badge-success {
  background: #00b050;
}

.badge-warning {
  background: #ffc107;
}

.btn-primary .active {
  background: #007bff;
  color: #ffffff;
}

.badge {
  color: white;
  padding: 8px;
  font-weight: 500;
  text-transform: uppercase;
}
.bg-due-ci-inactive {
  background-color: #f6c6ad;
}
.bg-dark-blue {
  background-color: #194c83;
}
.bg-orange {
  background-color: #e97132;
  color: #e97132;
}
</style>